import React, { useState } from 'react';
import { Button, UncontrolledTooltip } from 'reactstrap';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import apifuctions from "../../api/functions";

const PROPERTIES = {
    "MOSTRAR": {
        fewSelected: "Mostrar {x} {labelMany}",
        allSelected: "Mostrar Todos l{a}s {labelMany}",
        icon: "fa fa-eye",
        color: "success",
    },
    "OCULTAR": {
        color: "danger",
        fewSelected: "Ocultar {x} {labelMany}",
        allSelected: "Ocultar Todos l{a}s {labelMany}",
        icon: "fa fa-eye-slash",
    }
};

const ShowItemBtn = (props) => {
    const {
        idComponent, multiSelect,
        id, multiSelectIDs, action, onSubmit,
        label, labelMany, femaleLabel, submitUrl,
    } = props;

    const [showSpinner, updateSpinner] = useState(false);
    const [modal, setModal] = useState(false);
    const toggle = () => setModal(!modal);

    const sendData = (evt) => {
        evt.preventDefault();
        updateSpinner(true);
        setModal(false);
        const data = {
            Show: action === "MOSTRAR",
            ids: multiSelectIDs() ? multiSelectIDs() : [],
        }
        const successCallback = (response) => {
            updateSpinner(false);
            onSubmit && onSubmit();
        }
        const failureeCallback = () => updateSpinner(false);
        apifuctions.put(submitUrl, null, data, successCallback, failureeCallback, failureeCallback);
    }

    const selectedItems = multiSelect ? (multiSelectIDs() ? multiSelectIDs().length : 0) : (id() ? 1 : 0);
    let msg = selectedItems > 0 && PROPERTIES[action].fewSelected ? (
        PROPERTIES[action].fewSelected.replace("{x}", selectedItems).replace("{labelMany}", labelMany)
    ) : (
        PROPERTIES[action].allSelected.replace("{labelMany}", labelMany)
    );

    let a =  femaleLabel ? "a":"o";
    msg = msg.replace("{a}", a);
    
    return (
        <div>
            <Button disabled={showSpinner} id={idComponent} onClick={() => setModal(true)} color={PROPERTIES[action].color} className="rounded tiny-btn">
                <i className={showSpinner ? "fa fa-spinner fa-spin" : PROPERTIES[action].icon} aria-hidden="true"></i>
            </Button>
            <Modal className={`modal-${PROPERTIES[action].color}`} isOpen={modal} toggle={toggle}>
                <ModalHeader toggle={toggle}>Visibilidad de {labelMany}</ModalHeader>
                <ModalBody>
                    <p>Items Seleccionados: <strong>
                        {
                            selectedItems > 0 ? (
                                selectedItems == 1 ? (
                                    `${selectedItems} ${label}`
                                ) : (
                                    `${selectedItems} ${labelMany}`
                                )
                            ) : (
                                `Tod${a}s l${a}s ${labelMany}`
                            )
                        }</strong></p>
                    <p>{`¿Esta seguro que desea ${msg}?`}</p>
                </ModalBody>
                <ModalFooter>
                    <Button color={PROPERTIES[action].color} onClick={sendData}>Confirmar</Button>{' '}
                    <Button color="secondary" onClick={toggle}>Cancelar</Button>
                </ModalFooter>
            </Modal>
            <UncontrolledTooltip placement="bottom" target={idComponent}>{msg}</UncontrolledTooltip>
        </div >
    )
}

export default ShowItemBtn;


// WEBPACK FOOTER //
// ./src/components/ShowItemBtn/ShowItemBtn.js